import { Select, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useFormInputs } from 'pages/revisions-module/template-editor/editors/form/input/FormInputsDataProvider';
import {
  IFormInputContext,
  IFormInputSpec,
  IFormInputSpecFieldUpdatedAt,
} from 'pages/revisions-module/template-editor/editors/form/types';
import { useMemo } from 'react';

interface FieldUpdatedAtInputPropertiesSubFormProps {
  form: UseFormReturnType<IFormInputSpec>;
  context: IFormInputContext;
}

/**
 * Property editor for the field-updated-at input type.
 */
export default function FieldUpdatedAtInputPropertiesSubForm({
  form,
  context,
}: FieldUpdatedAtInputPropertiesSubFormProps) {
  const { allInputs } = useFormInputs();

  const options = useMemo(
    () =>
      allInputs
        .filter((input) => input.context === context && input.spec.name !== form.values.name)
        .map(({ spec }) => ({ value: spec.name, label: spec.label })),
    [allInputs, context, form.values.name]
  );

  const spec = form.values as IFormInputSpecFieldUpdatedAt;

  return (
    <Stack spacing={12}>
      <Select
        required
        label="Sledované pole"
        placeholder={options.length === 0 ? 'Najprv vytvorte iné polia' : undefined}
        searchable
        data={options}
        nothingFound="Žiadne pole"
        disabled={options.length === 0}
        value={spec.sourceField ?? ''}
        onChange={(value) => form.setFieldValue('sourceField', value || '')}
      />
    </Stack>
  );
}
